/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 1,
    stt: "I",
    sttBold: true,
    code: "[09]",
    codeBold: true,
    asset: "Số thu từ cổ phần hóa phải nộp ngân sách nhà nước",
    assetBold: true,
    readOnly: false,
    valueBold: true,
    value: { number: 0 },
  },
  {
    id: 2,
    stt: "II",
    sttBold: true,
    code: "[10]",
    codeBold: true,
    asset: "Số thu từ cổ phần hóa đx nộp ngân sách nhà nước, trong đó:",
    assetBold: true,
    readOnly: true,
    valueBold: true,
    value: { number: 0 },
  },
  {
    id: 3,
    stt: "1",
    sttBold: false,
    code: "[11]",
    codeBold: true,
    asset: "Tiền thu từ bán đấu giá công khai ra công chúng",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 4,
    stt: "2",
    sttBold: false,
    code: "[12]",
    codeBold: true,
    asset: "Tiền thu từ bán đấu giá cho các nhà đầu tư chiến lược",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 5,
    stt: "3",
    sttBold: false,
    code: "[13]",
    codeBold: true,
    asset: "Tiền thu từ bảo lãnh phát hành",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 6,
    stt: "4",
    sttBold: false,
    code: "[14]",
    codeBold: true,
    asset:
      "Tiền thu từ bán thỏa thuận cho các nhà đầu tư (bao gồm cả nhà đầu tư chiến lược), bán cổ phần ưu đãi cho tổ chức công đoàn, người lao động và người quản lý doanh nghiệp",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 7,
    stt: "5",
    sttBold: false,
    code: "[15]",
    codeBold: true,
    asset: "Tiền thu theo phương thức dựng sổ",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 8,
    stt: "6",
    sttBold: false,
    code: "[16]",
    codeBold: true,
    asset: "Tiền thu từ cổ phần hóa tại thời điểm chính thức chuyển thành công ty cổ phần",
    assetBold: false,
    assetCenter: false,
    readOnly: false,
    valueBold: false,
    value: { number: 0 },
  },
  {
    id: 9,
    stt: "III",
    sttBold: true,
    code: "[17]",
    codeBold: true,
    asset: "Số thu từ cổ phần hóa còn phải nộp ngân sách nhà nước",
    assetBold: true,
    assetCenter: true,
    readOnly: true,
    valueBold: true,
    value: { number: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={{ ...tableStyle, marginBottom: 30 }}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.codeBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.code}
                  </Td>
                  <>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.readOnly === true ? "bold" : 400,
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="number"
                        readOnly={rows.readOnly}
                        value={rows.value.number}
                        onChange={handleChange}
                        fontWeight={rows.valueBold}
                      />
                    </Td>
                  </>
                </tr>
              ))}
          </tbody>
        </table>
        <Typography variant="h4" fontStyle="italic" fontSize={14}>
          - Ghi chú: Chỉ tiêu [10] Số thu từ cổ phần hóa đã nộp ngân sách nhà nước: Tương ứng với số
          thu từ Cổ phần hóa đã kê khai phát sinh
        </Typography>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
